import { useQuery } from "@tanstack/react-query";
import type { GoogleAnalyticsTrafficDto, PlatformStatus } from "shared";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { useFeatureFlag } from "../hooks/use-app-metadata";
import { QueryKeys } from "../LinkGen";

export const useGoogleAnalyticsStatus = () => {
	const { id: companyId } = useCompany();
	const isEnabled = useFeatureFlag("GoogleAnalyticsIntegration");

	return useQuery({
		queryKey: QueryKeys.Integrations.Google.Analytics.Status(companyId),
		queryFn: async (): Promise<PlatformStatus> => {
			if (!isEnabled) {
				return { connected: false };
			}
			return (await Api.GoogleAnalyticsStatus()).data;
		},
	});
};

export const useGoogleAnalyticsTraffic = (connected: boolean) => {
	const { id: companyId } = useCompany();

	return useQuery({
		queryKey: QueryKeys.Integrations.Google.Analytics.Traffic(companyId),
		queryFn: async (): Promise<GoogleAnalyticsTrafficDto> => {
			return (await Api.GoogleAnalyticsGetTraffic()).data;
		},
		enabled: connected,
		staleTime: 24 * 60 * 60 * 1000,
	});
};
